import { RestrictionTypes } from 'partsOld/enums';

export const companyPartListDefaultPayload = {
  filters: {
    restrictionType: RestrictionTypes.INVENTORY_ANY_LOCATION,
  },
};
